import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col} from 'react-bootstrap'
import {linkFinder} from '../../core/links'
import Box from '../../core/components/Box'
import ProviderStats from './ProviderStats'
import ProviderStream from './ProviderStream'
import ReferenceProviderCompanyModal from './ReferenceProviderCompanyModal'
import i18n from '../i18n'

class ProviderStreamLayout extends Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        this.state = {
            opened: false
        }
    }

    _open() {
        this.setState({opened: true})
    }

    _close() {
        this.setState({opened: false})
    }

    render() {
        const {dispatch, location, authenticated, _links} = this.props
        const {opened} = this.state

        const newProviderBoxTitle = (
            <h3>{i18n.newProvider}</h3>
        )

        return (
            <div>
                <Row>
                    <Col sm={4} smPush={8}>
                        <ProviderStats />
                        {_links.find(linkFinder('ReferenceProviderCompany')) && location.pathname == '/providers' && ['superUser', 'callCenterUser'].indexOf(authenticated.userType) >= 0 && (
                            <Box
                                status='primary'
                                header={newProviderBoxTitle}
                                help='+'
                                onClick={() => this._open()}>
                            </Box>
                        )}
                    </Col>
                    <Col sm={8} smPull={4}>
                        <ProviderStream />
                    </Col>
                </Row>
                {_links.find(linkFinder('ReferenceProviderCompany')) && location.pathname == '/providers' && ['superUser', 'callCenterUser'].indexOf(authenticated.userType) >= 0 && (
                    <ReferenceProviderCompanyModal
                        show={opened}
                        onHide={() => this._close()}/>
                )}
            </div>
        )
    }
}

ProviderStreamLayout = connect((state) => ({
    location: state.router.location,
    authenticated: state.user.authenticated,
    _links: state.provider._links
}))(ProviderStreamLayout)

export default ProviderStreamLayout


// WEBPACK FOOTER //
// ./lib/provider/components/ProviderStreamLayout.js